<template>
    <div>
        <div class="el-Require">
            <el-row class="page_content">
                <h1 class="head_title">学历资格审查</h1>

                <div class="material-container">
                    <h2 class="section-title">上传学历证明材料</h2>

                    <!-- 未通过原因说明 -->
                    <div class="reason-box">
                        <div class="reason-title">
                            成教专升本入学新生上传专科学历信息未通过审查原因和解决办法：
                        </div>
                        <div class="reason-subtitle">未通过的具体原因是：</div>
                        <div class="reason-list">
                            <p>
                                1、2002年以前毕业的学生（此前学历信息未采集身份证号）<br />
                                解决办法：上传毕业证书或学历认证报告扫描件至本平台，并保证以下内容清晰可辨识：毕业时间、证书编号、毕业院校。
                            </p>
                            <p>
                                2、军队院校（此类学历身份证号为军士证号）或自考毕业的学生<br />
                                解决办法：上传毕业证书或学历认证报告扫描件至本平台，并保证以下内容清晰可辨识：毕业时间、证书编号、毕业院校。
                            </p>
                            <p>
                                3、专科毕业后读本之前，单更名或修改了身份证号<br />
                                解决办法：除上传毕业证书或学历认证报告扫描件外，还需要上传身份证的签发机关（派出所）提供的姓名变更证明或身份证号变更证明扫描件。或者上传记录了曾用名或身份证号变更信息的户口本的扫描件。
                            </p>
                            <p>
                                4、因暂无专科毕业照片，学信网未提供网上查询。<br />
                                解决办法：除上传毕业证书或学历认证报告扫描件外，还须向毕业院校申请复核、补照片、关联毕业照片。
                            </p>
                            <p>
                                5、学生学历证书上或学信网上学历注册信息中姓名或身份证号错误，确属于原发证学校未发现造成信息错误的。<br />
                                解决办法：除上传毕业证书或学历认证报告扫描件外，还须向毕业院校申请学历勘误或进行学历认证。
                            </p>
                            <p>
                                6、国外或境外学历学位<br />
                                解决办法：除上传毕业证书扫描件外，还需向教育部留学服务中心申请国（境）外学历学位认证，上传国（境）外学历学位认证报告扫描件。
                            </p>
                            <p>
                                7、其他原因<br />
                                解决办法：除上传毕业证书扫描件外，还请直接接学历认证，待学历认证报告出来后上传学历认证报告扫描件至本平台。
                            </p>
                        </div>
                    </div>

                    <!-- 表单区域 -->
                    <div class="form-section">
                        <!-- 完整表单包裹 -->
                        <!-- 表单区域 -->
                        <div class="form-card">
                            <el-form
                                ref="formRef"
                                :model="form"
                                :rules="rules"
                                label-width="180px"
                                class="common-form"
                                :disabled="isEdit"
                            >
                                <el-form-item
                                    label="报告编号/在线验证码"
                                    prop="onlineCode"
                                >
                                    <el-input
                                        v-model="form.onlineCode"
                                        placeholder="请填写学历报告编号或在线验证码"
                                        class="form-input"
                                        clearable
                                    />
                                </el-form-item>

                                <el-form-item
                                    label="专科毕业证书编号"
                                    prop="collegeCertNo"
                                >
                                    <el-input
                                        v-model="form.collegeCertNo"
                                        placeholder="请填写专科毕业证书编号"
                                        class="form-input"
                                        clearable
                                    />
                                </el-form-item>

                                <el-form-item
                                    label="专科毕业院校名称"
                                    prop="collegeSchoolName"
                                >
                                    <el-input
                                        v-model="form.collegeSchoolName"
                                        placeholder="请填写专科毕业院校全称"
                                        class="form-input"
                                        clearable
                                    />
                                </el-form-item>

                                <el-form-item
                                    label="专科所学专业"
                                    prop="collegeMajorName"
                                >
                                    <el-input
                                        v-model="form.collegeMajorName"
                                        placeholder="请填写专科所学专业名称"
                                        class="form-input"
                                        clearable
                                    />
                                </el-form-item>

                                <!-- 上传区域 -->
                                <el-form-item
                                    label="证明材料上传"
                                    prop="photoUrl"
                                >
                                    <div class="upload-tip">
                                        <p>图片格式要求：</p>
                                        <p>
                                            1、您上传的文件大小请保持在10M以内。
                                        </p>
                                        <p>
                                            2、请保证图片字迹清晰且头像可辨识。
                                        </p>
                                    </div>
                                    <el-upload
                                        :action="uploadUrl"
                                        list-type="picture-card"
                                        :file-list="form.photoUrl"
                                        :on-preview="handlePreview"
                                        :headers="headers"
                                        :on-remove="handleRemove"
                                        :before-remove="beforeRemove"
                                        :on-exceed="handleExceed"
                                        :on-success="handleSuccess"
                                        multiple
                                        :limit="10"
                                        accept="image/png,image/jpeg,image/jpg"
                                    >
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </el-form-item>

                                <el-form-item class="btn-wrapper">
                                    <el-button
                                        :disabled="isEdit"
                                        type="primary"
                                        size="default"
                                        @click="handleSubmit"
                                    >
                                        确认提交材料
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </el-row>
        </div>

        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import APIDOC from "@/common/serverApi";
import { getCookieForRoleTag } from "../../common/ulit";
import {
    get,
    post,
    postJSON,
    postParams,
    postFormData,
} from "@/common/request";
export default {
    name: "AddReviewProgram",
    data() {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            headers: {
                token: getCookieForRoleTag(),
                _role_tag: getCookieForRoleTag()
                    ? getCookieForRoleTag().split(".")[
                          getCookieForRoleTag().split(".").length - 1
                      ]
                    : null,
            }, //请求头
            formRef: null,
            isEdit: false,
            form: {
                onlineCode: "",
                collegeCertNo: "",
                collegeSchoolName: "",
                collegeMajorName: "",
                photoUrl: [],
            },
            rules: {
                onlineCode: [
                    {
                        required: true,
                        message: "请填写报告编号/在线验证码",
                        trigger: "blur",
                    },
                ],
                collegeCertNo: [
                    {
                        required: true,
                        message: "请填写专科毕业证书编号",
                        trigger: "blur",
                    },
                ],
                collegeSchoolName: [
                    {
                        required: true,
                        message: "请填写专科毕业院校名称",
                        trigger: "blur",
                    },
                ],
                collegeMajorName: [
                    {
                        required: true,
                        message: "请填写专科所学专业",
                        trigger: "blur",
                    },
                ],
                photoUrl: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.photoUrl.length === 0) {
                                callback(new Error("请至少上传一张证明材料"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change",
                    },
                ],
            },
        };
    },
    methods: {
        // 图片预览
        handlePreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 移除文件
        handleRemove(file, photoUrl) {
            this.form.photoUrl = photoUrl;
        },
        // 删除前确认
        beforeRemove(file) {
            return this.$confirm(`确定删除【${file.name}】吗？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            });
        },
        // 超出数量限制
        handleExceed() {
            this.$message.warning("最多只能上传10张图片，请删除后再试");
        },
        // 上传成功
        handleSuccess(res, file) {
            console.log("上传成功：", this.$baseUrl);
            console.log("上传成功：", res, file);
            this.form.photoUrl.push(file);
        },
        // 提交表单
        handleSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (!valid) {
                    return;
                }
                const studentStatusId = JSON.parse(
                    sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag())
                ).studentStatusId;

                let params = {
                    studentStatusId,
                    ...this.form,
                    photoUrl: this.form.photoUrl
                        .map((item) => item.response.data.url)
                        .join(","),
                };

                post(APIDOC.USER.submitStudentApplyInfo, {
                    studentStatusId,
                    ...params,
                }).then((res) => {
                    if (res.statusId) {
                        this.$message.success("材料提交成功，等待审核");
                        this.getData();
                    }
                });
                // // 模拟提交接口
                // this.$message.success("材料提交成功，等待审核");
                // console.log("提交数据：", studentStatusId);
                // console.log("最终提交数据：", params);
            });
        },

        // 获取详情
        getData() {
            const studentStatusId = JSON.parse(
                sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag())
            ).studentStatusId;
            get(APIDOC.USER.getStudentDataInfo, {
                studentStatusId,
            }).then((res) => {
                console.log("获取详情：", res);
                console.log("获取详情：");
                if (res.code === 0) {
                    if (res.data.onlineCode && res.data.onlineCode) {
                        this.isEdit = true;
                    } else {
                        this.isEdit = false;
                    }

                    this.form = {
                        onlineCode: res.data.onlineCode,
                        collegeCertNo: res.data.collegeCertNo,
                        collegeSchoolName: res.data.collegeSchoolName,
                        collegeMajorName: res.data.collegeMajorName,
                        photoUrl: res.data.photoUrl
                            ? res.data.photoUrl.split(",").map((item) => ({
                                  url:
                                      this.$baseUrl +
                                      item.replace(/\\\\/g, "\\"),
                              }))
                            : [],
                    };
                }
            });
        },
    },

    mounted() {
        this.getData();
    },
};
</script>

<style scoped>
/* 容器 */
.material-container {
    max-width: 900px;
    /* margin: 30px auto; */
    padding: 0 20px;
    position: relative;
}

/* 标题 */
.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 16px;
}

/* 红色边框说明框 */
.reason-box {
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 20px;
}
.reason-title {
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 14px;
}
.reason-subtitle {
    font-size: 13px;
    margin-bottom: 8px;
}
.reason-list {
    font-size: 13px;
    line-height: 1.8;
}
.reason-list p {
    margin-bottom: 10px;
}

/* 表单区域 */
.form-section {
    padding: 20px;
    border-radius: 4px;
}
.form-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}
.form-row:last-child {
    margin-bottom: 0;
}
.form-label {
    width: 160px;
    font-size: 14px;
    color: #333;
}
.form-input {
    flex: 1;
}

/* 上传区域 */
.upload-section {
    padding: 20px;
    padding-top: 0px;
    border-radius: 4px;
    margin-bottom: 20px;
}
.upload-tip {
    font-size: 12px;
    color: #666;
    margin-bottom: 12px;
    line-height: 1.6;
}

/* 按钮 */
.btn-box {
    text-align: center;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/addReviewProgram/index.vue